import CarRow from "./CarRow";
import "../../styles/table.css";

export default function CarTable({ cars, onView, onEdit, onDelete, onToggleApprove }) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Véhicule</th>
            <th>Propriétaire</th>
            <th className="center">Spécifications</th>
            <th className="center">Approuvé</th>
            {/* <th className="center">Actions</th> */}
          </tr>
        </thead>

        <tbody>
          {cars.map((car) => (
            <CarRow
              key={car.id}
              car={car}
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
              onToggleApprove={onToggleApprove}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}